import React, { Component } from 'react';
import { sensorsMonitor } from '@/utils/utils';
import '@/assets/css/lending-licence.scss';

const SaSdk = sensorsMonitor();
class LendingLicence extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  // 数据打点相关
  sensorsInit() {
    SaSdk.registerPage({
      current_url: window.location.href,
      pagename: 'LendingLicence',
    })

    SaSdk.quick('autoTrack');
    SaSdk.track('LendingLicence_open');
  }

  componentDidMount() {
    document.title = 'Why we need your NIN?';
    this.sensorsInit();
  }

  render() {
    // todo 暂时没有时间控制 直接写死 后期优化
    return <div className='lending-licence'>
      <h2>Why we need your NIN?</h2>
      <p>We need your NIN to verify your identity to avoid financial losses caused by someone posing as you to borrow money on our app. We are Licenced by th Uganda Microfinance Regulatory Authority, Your information will be kept confidential, please feel free to fill in. license NO. ML 1908</p>

      <div className="licence">
        <img src="https://static-af.obs.af-south-1.myhuaweicloud.com/web/app-h5/app/ucredit/licence.png" alt="mib" />
      </div>
    </div>
  }
}

export default LendingLicence;
